import { useCallback, useMemo, useSyncExternalStore } from "react";

export const useMediaQuery = (width: number, factor: "min" | "max" = "max") => {
  const q = useMemo(() => {
    return window.matchMedia(`(${factor}-width: ${width}px)`);
  }, [width, factor]);

  const getSnapshot = () => q.matches;
  const subscribe = useCallback(
    (callback: () => void) => {
      q.addEventListener("change", callback);
      return () => q.removeEventListener("change", callback);
    },
    [q],
  );
  return useSyncExternalStore(subscribe, getSnapshot);
};
